<app-navbar></app-navbar> 

<div class="d-flex">

  <div >
    <app-sidebar style="width: 250px; min-width: 250px; height: 100%;"></app-sidebar>
  </div>
  
  <div style="flex-grow: 1;">
    <router-outlet></router-outlet> 
  </div>
  
</div>
